import { render, staticRenderFns } from "./features-library-final.vue?vue&type=template&id=66541734&scoped=true&"
import script from "./features-library-final.vue?vue&type=script&lang=js&"
export * from "./features-library-final.vue?vue&type=script&lang=js&"
import style0 from "./features-library-final.vue?vue&type=style&index=0&id=66541734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66541734",
  null
  
)

component.options.__file = "features-library-final.vue"
export default component.exports